import { useQuery } from "@tanstack/react-query";

import Collaborator from "../@types/Collaborator";
import { filterToParams } from "../utils/filter";
import { FilterValues } from "../@types/filter";
import { api } from "./api";

export type FetchUsersResponse = {
  content: Collaborator[];
  totalElements: number;
  totalPages: number;
  pageable: {
    pageNumber: number;
    pageSize: number;
    totalElements: number;
    paged: boolean;
  };
};

export const fetchUser = async (): Promise<Collaborator> => {
  const response = await api.get<Collaborator>(`/collaborator/logged`);
  return response.data;
};

export const fetchUsers = async (
  filters?: FilterValues & { page?: number; size?: number },
): Promise<FetchUsersResponse> => {
  const response = await api.get<FetchUsersResponse>(`/report_entries/totals/by_collaborator`, {
    params: filterToParams(filters!, filters?.page, filters?.size),
  });

  return response.data;
};

export const useUsers = (filters?: FilterValues & { page?: number; size?: number }, shouldFetch: boolean = true) => {
  return useQuery({
    queryKey: ["users", filters],
    queryFn: () => fetchUsers(filters),
    enabled: shouldFetch,
  });
};
